import type { CommonStylesPalette } from '../types.d';

export const tableStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .table': {
    border: 0,
    '& > thead > tr > th': {
      fontWeight: 600,
      verticalAlign: 'top',
      border: `1px solid ${palette.neutralLight} !important`,
      '&:first-child': {
        borderLeft: '0 !important',
      },
      '&:last-child': {
        borderRight: '0 !important',
      },
      '&.column-header-sortable': {
        cursor: 'pointer',
        '& .glyphicon-arrow-up:before': {
          content: '"\\EE68"',
          fontFamily: iconFontFamily,
        },
        '& .glyphicon-arrow-down:before': {
          content: '"\\EE69"',
          fontFamily: iconFontFamily,
        },
      },
      '&.column-name-isIncludedOrExcluded > span': {
        maxWidth: '100%', // Fix word break for Ad group include/Exclude setting
      },
      '& span': {
        display: 'inline-block',
        maxWidth: '80%',
      },
    },
    '& > tbody > tr > td': {
      verticalAlign: 'middle',
      padding: '0 10px',
      lineHeight: 1.8,
      border: `1px solid ${palette.neutralLight}`,
      '&:first-child': {
        borderLeft: '0 !important',
      },
      '&:last-child': {
        borderRight: '0 !important',
      },
    },
    '& > tfoot > tr > td': {
      '&:first-child': {
        borderLeft: '0 !important',
      },
      '&:last-child': {
        borderRight: '0 !important',
      },
    },
  },

  '& .table__row--indent td:first-child': {
    paddingLeft: '32px !important',
  },

  '& .bidBoost-percentValue': {
    width: 'fit-content',
    display: 'inline-block',
  },
});
